import 'antd/dist/antd.css';
import axios from '../../utils/request';
import React, { Component } from "react";
import { Spinner } from 'reactstrap';
import { Result, Typography, Space } from 'antd';
import './Starbucks_BPMSendHiring.css'
import {
    SmileOutlined,
    SmileTwoTone,
    FrownTwoTone,
    FrownOutlined
} from '@ant-design/icons';
const { Title, Paragraph, Text } = Typography;


export class Starbucks_BPMSendHiring extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",
            tenantId: "",
            userId: "",
            commonParamater: "",
            applyId: "",
            applicantId: "",
            styles:"",
        }
    };

    componentDidMount() {
        //this.loadPage(null, null, null, null, null);
        if (
            navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i)
        ) {
            this.setState({ styles: "phone"});
            // 移动端适配
        } else {
            this.setState({ styles:"pc"});
        }
        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");

        //if (!commonParamater) {
        //    this.setState({ errorMessage: "commonParamater不存在！", isLoading: false, isReady: true });
        //    return;
        //}
        this.state.commonParamater = commonParamater;
        this.loadPage(commonParamater);

        window.addEventListener('pageshow', function (event) {
            console.log('after , pageshow :', event);
        });
    };

    loadPage = (commonParamater) => {
        const params = {
            commonParamater
        }
        axios
            .get("/api/stb/BPMHiring/SendHiring", { params: params })
            .then(res => {
                let errorMessage = "";

                if (res.status !== 200 || res.data.code !== "200") {
                    errorMessage=res.data.message
                }

                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！"+reason });
            })
            .finally(
            );
    };

    render() {
        if (this.state.isReady) {
            if (this.state.styles != "phone") {
                if (this.state.errorMessage !== "") {
                    return <div className='parent'>
                        <div className='child_error'>
                            <div className="i_icon"><FrownOutlined /> </div>
                            <div className="i_text" ><label>{this.state.errorMessage}</label></div>
                        </div>
                    </div >
                }
                else {
                    return <div className='parent'>
                        <div className='child_sucess'>
                            <div className="i_icon"><SmileOutlined /> </div>
                            <div className="i_text" ><label>雇佣申请创建中,创建成功后会以消息的方式通知您!</label></div>
                        </div>
                    </div>
                }
            }
            else {
                if (this.state.errorMessage !== "") {
                    return <Typography className="phone_parent">
                        <Paragraph className="phone_child_error">
                            <SmileOutlined />
                            <Text className="phone_text" style={{ color: '#ff4d4f' }} >{this.state.errorMessage}</Text>
                        </Paragraph>
                    </Typography>

                }
                else {
                    return <Typography className="phone_parent">
                        <Paragraph className="phone_child_sucess">
                            <SmileOutlined />
                            <Text className="phone_text" style={{ color:'#044736'}} >雇佣申请创建中,创建成功后会以消息的方式通知您!</Text>
                        </Paragraph>
                    </Typography>
                }
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}